import React from 'react';

import Checkbox from 'material-ui/Checkbox';
import { FormLabel, FormHelperText } from 'material-ui/Form';

const errorText = {
    display: 'flex',
    justifyContent: 'center',
    color: 'red'
};


const renderCheckBoxGroup = ({ input, options, checked, label, className, handleCheckChange, meta: { touched, error }, ...rest }) => {
    return (
        (
            <div className={`${'checkBoxDiv'} ${className}`}>
                <FormLabel >
                    {label}
                </FormLabel>
                {
                    options.map(option => (
                        <FormLabel key={option.id}>
                            <Checkbox
                                name={input.name}
                                value={option.label}
                                checked={checked === option.label}
                                style={{ color: '#002053' }}
                                onChange={handleCheckChange}
                                {...rest}
                            />
                            {option.label}
                        </FormLabel>
                    ))
                }
                {
                    error &&
                    <FormHelperText style={errorText}>{error}</FormHelperText>
                }
            </div>
        )
    )
    
}

export default renderCheckBoxGroup;


// WEBPACK FOOTER //
// ./src/helpers/RenderCheckBoxGroup.js